import { useCallback } from "react";

import { useRequest } from "../../../shared/hooks/useRequest";
import { getPurchaseCourse } from "../api/courseApi";

export const usePurchaseCourse = (courseId?: string) => {
    const fetcher = useCallback(
        (signal: AbortSignal) => getPurchaseCourse(courseId as string, signal),
        [courseId]
    );

    return useRequest(courseId ? fetcher : null);
};